import { default as React } from 'react';
import { safeRender } from '../../../shared';
import { getAppState, DisplayDialog } from '../../../appstate';
import { connect } from 'react-redux';
import type { Store } from 'redux';
import { createLazyComponent, LazyModule } from 'owa-bundling';

// TODO: Instead of importing Async Components for two-hop import, switch to createWithReducer

const importContactsModule = new LazyModule(
    () => import(/* webpackChunkName: "ImportContacts" */ '../../../importcontacts')
);
// tslint:disable-next-line:variable-name
const ImportContactsDialogAsync = createLazyComponent(
    importContactsModule,
    m => m.ImportContactsDialogAsync
);

const exportContactsModule = new LazyModule(
    () => import(/* webpackChunkName: "ExportContacts" */ '../../../exportcontacts')
);
// tslint:disable-next-line:variable-name
const ExportContactsDialogAsync = createLazyComponent(
    exportContactsModule,
    m => m.ExportContactsDialogAsync
);

const contactCleanupModule = new LazyModule(
    () => import(/* webpackChunkName: "ContactCleanup" */ '../../../contactcleanup')
);
// tslint:disable-next-line:variable-name
const ContactCleanupDialogAsync = createLazyComponent(
    contactCleanupModule,
    m => m.ContactCleanupDialogAsync
);

type ViewProps = { currentDialog: DisplayDialog };
const asyncDialogLoader = (props: ViewProps & { store: Store<{}> }): JSX.Element => (
    <>
        {props.currentDialog === DisplayDialog.ImportContacts && (
            <ImportContactsDialogAsync store={props.store} />
        )}
        {props.currentDialog === DisplayDialog.ExportContacts && (
            <ExportContactsDialogAsync store={props.store} />
        )}
        {props.currentDialog === DisplayDialog.ContactCleanup && (
            <ContactCleanupDialogAsync store={props.store} />
        )}
    </>
);

const mapStateToProps = (rootState: {}): ViewProps => {
    const state = getAppState(rootState);
    return { currentDialog: state.view.asyncDialogState.displayedDialogType };
};

export default connect<ViewProps, undefined, { store: Store<{}> }>(mapStateToProps)(
    safeRender(asyncDialogLoader, 'AsyncDialogLoader')
);
